/**
 * Mixin for showing toast (snackbar) messages in restaurant module.
 * Use with v-snackbar in template and call this.showToast(message, color) after operations.
 */
export default {
  data () {
    return {
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
    }
  },
  methods: {
    showToast (text, color = 'success') {
      this.snackbarText = text
      this.snackbarColor = color === 'error' ? 'error' : (color || 'success')
      this.snackbar = true
    },
  },
}
